import { render } from "./SaveDraftModal.vue?vue&type=template&id=689f8e64"
import script from "./SaveDraftModal.vue?vue&type=script&lang=js"
export * from "./SaveDraftModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__